import axios from '@/core/axios';

import {
  ProductionTrackingLinesQuery,
  ProductionTrackingLinesResponse,
  ProductionTrackingQuery,
  ProductionTrackingSummary
} from './production-tracking.types';

const compactParams = (params: object): Record<string, unknown> =>
  Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== ''));

/* Module Analyses > Suivi de production : avancement des expéditions du jour (temps réel, sans cache) */
export class ProductionTrackingService {
  summary(query: ProductionTrackingQuery = {}): Promise<ProductionTrackingSummary> {
    return axios
      .get<ProductionTrackingSummary>('/production-tracking', { params: compactParams(query) })
      .then(resp => resp?.data);
  }

  /* Lignes de commande d'une étape (paginées) */
  lines(query: ProductionTrackingLinesQuery): Promise<ProductionTrackingLinesResponse> {
    return axios
      .get<ProductionTrackingLinesResponse>('/production-tracking/lines', { params: compactParams(query) })
      .then(resp => resp?.data);
  }
}

export const productionTrackingService = new ProductionTrackingService();
